import * as React from 'react';
import { SmallBodyText } from '../../../../../../ui-toolkit';
import { hasAmericanDigitalUnderwriter } from '../../../../../../utilities/order/hasAmericanDigitalUnderwriter';
import { IParty } from '../../../../../../ui-toolkit/orders/interfaces/IParty';

export interface IAmericanDigitalDisclaimerProps {
  parties: IParty[];
}

export const AmericanDigitalDisclaimer: React.FC<IAmericanDigitalDisclaimerProps> = ({ parties }) => (
  <>
    {hasAmericanDigitalUnderwriter(parties) && (
      <SmallBodyText intent="italic">
        An internal transfer to the premium escrow account is not available for this order. Remittance payments to
        American Digital should be made via an ACH Push.
      </SmallBodyText>
    )}
  </>
);
